import { useCallback, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCaretLeft } from '@fortawesome/free-solid-svg-icons/faSquareCaretLeft';
import { UndeliveredParams } from '@api/order-reporting/types/UndeliveredParams';
import { ReportType } from '@api/order-reporting/types/ReportType';
import { UndeliveredGridData } from '@pages/reporting-pages/undelivered-orders/types/UndeliveredGridData';
import useOrderClick from '@hooks/reportings/useOrderClick';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { useSaveOrderCommentMutation } from '@api/order-reporting/commentApi';
import EditableGridCell from 'components/editable-grid-cell/EditableGridCell';



interface GridRowProps {
	item: UndeliveredGridData,
	rowIndex: number,
	validParams: UndeliveredParams
}
  

const GridRow = (props: GridRowProps) => {
	const { rowIndex, validParams } = props;
	const { orderCustomerSapId, name, city, street, salesMan, tlsOperator, comment, orderClientId, distributionType, shipmentDistributionCode, cancelledBy,
		orderUnversionedSystemId, orderRequiredDeliveryDate, orderRequiredDeliveryDateISO, orderExecutionPlace, orderSentVolume, orderSentCount, phase } = props.item;

	const hasPermission = useHasPermission();
	const orderClick = useOrderClick({ date: orderRequiredDeliveryDateISO, orderUnvId: orderUnversionedSystemId });
	const [ saveComment, { data, isError } ] = useSaveOrderCommentMutation();

	const getClassName = useCallback((centered: boolean, leftAlign: boolean = false) => 
		`app-grid-cell${
			rowIndex % 2 == 0 ? ' secondary-cell' : ' primary-cell'
		}${
			leftAlign ? ' left-align-cell' : ''
		}${
			centered ? ' centered-cell' : ''
		}`
	,[ rowIndex ]);


	return (
		<>
			<div className={getClassName(true)}>
				{hasPermission(AppRolesEnum.orders_Read) &&
					<FontAwesomeIcon className='order-link-icon' icon={faSquareCaretLeft} onClick={orderClick} />}
			</div>

			<div className={getClassName(true)}>
				<p>{orderCustomerSapId ? orderCustomerSapId : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{name ? name : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{city ? city : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{street ? street : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{salesMan ? salesMan : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{tlsOperator ? tlsOperator : '-'}</p>
			</div>

			<EditableGridCell
				requiredRoles={AppRolesEnum.orderReports_Modify}
				className={getClassName(true)}
				isApiError={data && !data.successfull ? true : isError}
				externalValue={comment}
				onPressSave={(value: string) => saveComment({
					unversionedSystemId: orderUnversionedSystemId,
					comment: value,
					reportType: ReportType.undeliveredReport,
					originalArgs: validParams
				})} />

			<div className={getClassName(true)}>
				<p>{orderClientId ? orderClientId : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{orderRequiredDeliveryDate ? orderRequiredDeliveryDate : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{orderExecutionPlace ? orderExecutionPlace : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{distributionType ? distributionType : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{shipmentDistributionCode ? shipmentDistributionCode : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{phase ? phase : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{cancelledBy ? cancelledBy : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{orderSentVolume}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{orderSentCount}</p>
			</div>
		</>
	)
}

export default memo(GridRow);